import { useAuth0, User } from "@auth0/auth0-react";
import React, { createContext, useEffect, useState } from "react";
import { Donor } from "../../../models";
import { useDonor } from "../../../_queries";
import { FullPageError } from "../../shared/layout/FullPageError/FullPageError";
import { FullPageSpinner } from "../../shared/layout/FullPageSpinner/FullPageSpinner";

export const DonorContext = createContext<{
  donor: Donor | null;
  setDonor: React.Dispatch<React.SetStateAction<Donor | null>>;
}>({ donor: null, setDonor: () => {} });

export const DonorProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { getAccessTokenSilently, user } = useAuth0();
  const [donor, setDonor] = useState<Donor | null>(null);

  const { loading, error, data } = useDonor(user, getAccessTokenSilently);
  const noData =
    typeof data !== "undefined" && (data === null || (Array.isArray(data) && data.length === 0));

  useEffect(() => {
    if (!noData && data !== undefined && data !== donor) {
      setDonor(data);
    }
  }, [data, donor, noData]);

  if (loading && user) {
    return <FullPageSpinner />;
  } else if (error) {
    return <FullPageError error={error.message} />;
  } else if (user && noData) {
    return <FullPageError title="No data available" />;
  }

  return <DonorContext.Provider value={{ donor, setDonor }}>{children}</DonorContext.Provider>;
};
